import React from "react";

function ApplicationSecurity() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">
            Application Security Assessment
          </span>
        </div>
        <p>
          Application Security Assessment is the assessment procedure for
          finding out the threats and knowing the gaps for bridging those. It
          helps in making the applications and software more secure.
          Sub-services we offer in Application Security Assessment are Web
          application penetration testing, API security testing, Mobile
          application penetration testing, and security code review.
        </p>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Web application penetration testing</h5>
                <div class="card-text mt-3 mb-3">
                  We perform the web application pentest to identify cyber
                  security risks, security hurdles, data leaks, and unauthorized
                  usage of web applications and the information stored in them.
                  Secure your web applications now to save yourself from
                  cleaning a big dirty mess by an unwanted guest later as/Rise
                  fearlessly now with web application penetration test because-
                  <ol className="mt-3">
                    <li>
                      It protects the organization's and customers' stored data
                      from hackers.
                    </li>
                    <li>
                      It maintains business flow by safeguarding it against
                      cybercriminals.
                    </li>
                    <li>
                      It sustains the company's rapport with its customers by
                      making their experience safe and smooth.
                    </li>
                    <li>
                      It fortifies the cyber defense system making it hard for
                      hackers to break in for data.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">API security testing</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    API is an application programming interface that is the
                    backend framework used for information transfer in websites
                    and apps. The API security testing checks the gaps,
                    vulnerability, and efficiency present at the API for
                    deterring and mitigating the attacks on the API for securing
                    the data.
                  </p>
                  <p>
                    Secure your API now to save yourself from cleaning a big
                    dirty mess by an unwanted guest later as/Rise fearlessly now
                    with API security test because-
                  </p>
                  <ol className="mt-3">
                    <li>
                      It identifies the problems before becoming a big problem.
                    </li>
                    <li>
                      API security test don't need UI(User interface) and user
                      interaction. It tests the API without spoiling a user's
                      experience.
                    </li>
                    <li>
                      API testing doesn't consume lots of time, making your
                      websites start operating again soon.
                    </li>
                    <li>
                      It tests the functions and functionality of API for smooth
                      working.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">
                  Mobile Application Penetration Testing
                </h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    The mobile application penetration test is an all-rounder
                    test used for examining the mobile app(iOS & Android). It
                    helps in reckoning the security perimeters in an app for
                    knowing the vulnerable points in an app.{" "}
                  </p>
                  <p>
                    Secure your mobile app now to save yourself from cleaning a
                    big dirty mess by an unwanted guest later as/Rise fearlessly
                    now with mobile application penetration test because-
                  </p>
                  <ol className="mt-3">
                    <li>
                      The mimicked attacks used in it find holes, vulnerability
                      points, and bugs.
                    </li>
                    <li>
                      Its assessment helps in making an app more secure and
                      user-friendly.
                    </li>
                    <li>
                      It helps in maintaining users' trust and business flow
                      without any trouble.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">
                  Security code review (website & application)
                </h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Reviewing the source code of a website and application
                    checks the strength and weaknesses of a source code. It
                    helps identify the potential threats and opportunities for
                    protection, making you have a perfect and perfectly secure
                    website and application matching the compliance standards
                    for users.
                  </p>
                  <p>
                    Secure your source code now to save yourself from cleaning a
                    big dirty mess by an unwanted guest later as/Rise fearlessly
                    now with security code review because-
                  </p>
                  <ol className="mt-3">
                    <li>
                      It helps in filtering the vulnerability before releasing the website and app.
                    </li>
                    <li>
                      It helps in fixing the defects present in the source code.
                    </li>
                    <li>
                      It minimizes the risks for the smooth functioning of the website and application.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplicationSecurity;
